<span class="content displayNone">{{appTitle}}</span>

<router-outlet ></router-outlet>
<app-wave-spinner *ngIf="showHideLoader"></app-wave-spinner>
